import {VehicleMotWarningResponseBody} from '@dms/api/core';

export const getVehicleMotWarningLayoutKey = (vehicle: VehicleMotWarningResponseBody) =>
  [
    vehicle.id,
    vehicle.title,
    vehicle.registrationPlate,
    vehicle.vin,
    vehicle.technicalInspectionValidUntil,
    vehicle.branchName,
  ].join(':');
